import { useNavigate } from "react-router-dom";
import ChevronDownIcon from "../../atoms/images/ChevronDownIcon";
import Text from "../content/Text";

export default function SettingsListItem({ label, text, to }) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(to)}
      className={`flex justify-between items-center pt-3 ${
        text ? "pb-1" : "pb-3"
      } px-3 border-b border-[#EDEDED] cursor-pointer hover:bg-gray-50`}
    >
      <div className="flex flex-col">
        <Text variant="label" className="text-[#757575]">
          {label}
        </Text>
        {text && (
          <Text variant="small" className="text-[#757575]">
            {text}
          </Text>
        )}
      </div>
      <div className="-rotate-90">
        <ChevronDownIcon size={12} className="text-vestelColor" />
      </div>
    </div>
  );
}
